// store/thunks/auth/verify2faCodeThunk.ts
import { MIN_LEN } from '@/constants';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { setRefreshToken, setSessionToken } from '@/utils/sessionStorage';
import type { FinilizeVerifyDTO } from '@/types/DTOs';
import { isJWTExpired } from '@/store/utils/jwtDecoder';

export const verify2faCodeThunk = createAppAsyncThunk<
  FinilizeVerifyDTO,
  { code: string },
  { rejectValue: { message: string; expired?: boolean } }
>('auth/verify2faCode', async ({ code }, { getState, extra: { authService }, rejectWithValue }) => {
  const state = getState();
  const twoFactorToken = state.auth.regToken;

  if (twoFactorToken === undefined || twoFactorToken.trim().length === MIN_LEN) {
    return rejectWithValue({ message: 'Missing two-factor token' });
  }

  if (isJWTExpired(twoFactorToken)) {
    return rejectWithValue({
      message: 'Your session expired. Please log in again.',
      expired: true,
    });
  }

  try {
    const result = await authService.verifyTwoFactorCode({
      code,
      twoFactorToken,
      method: state.auth.twoFactorMethod ?? 'sms',
    });
    setSessionToken(result.sessionToken);
    setRefreshToken(result.refreshToken);
    return result;
  } catch (caught) {
    const message = caught instanceof Error ? caught.message : 'Failed to verify 2FA code';
    return rejectWithValue({ message });
  }
});
